import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import {
  MagnifyingGlassIcon,
  ChartBarIcon,
  DocumentTextIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';

const SEOOptimization = () => {
  const serviceData = {
    icon: MagnifyingGlassIcon,
    title: 'SEO Optimization',
    description: 'Boost your online visibility and drive organic traffic with our comprehensive SEO strategies and digital marketing solutions. Get found by your target audience.',
    gradient: 'from-green-900 to-emerald-900',
    technologies: [
      'Google Analytics',
      'Search Console',
      'SEMrush',
      'Ahrefs',
      'Screaming Frog',
      'Yoast SEO',
    ],
    features: [
      {
        icon: ChartBarIcon,
        title: 'Keyword Research',
        description: 'In-depth analysis to find the best keywords for your business goals.',
      },
      {
        icon: DocumentTextIcon,
        title: 'Content Optimization',
        description: 'Optimizing your content to rank higher and engage your audience.',
      },
      {
        icon: LinkIcon,
        title: 'Link Building',
        description: 'Building high-quality backlinks to increase your domain authority.',
      },
    ],
    services: [
      'Comprehensive SEO Audit',
      'Keyword Research & Strategy',
      'On-Page Optimization',
      'Technical SEO',
      'Content Marketing',
      'Link Building Campaign',
      'Local SEO',
      'Performance Tracking & Reporting',
    ],
    whyChoose: [
      'Proven Track Record of Results',
      'White-Hat SEO Practices Only',
      'Detailed Monthly Reports',
      'Continuous Strategy Optimization',
    ],
  };

  return <ServiceTemplate {...serviceData} />;
};

export default SEOOptimization;
